__turbopack_context__.v({
  "brandCard": "BrandCard-module-scss-module__YLcPwG__brandCard",
  "content": "BrandCard-module-scss-module__YLcPwG__content",
  "showcaseSlot": "BrandCard-module-scss-module__YLcPwG__showcaseSlot",
  "title": "BrandCard-module-scss-module__YLcPwG__title",
  "verifiedLink": "BrandCard-module-scss-module__YLcPwG__verifiedLink",
});
